var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.currentFile
      ? _c("div", { staticClass: "progress mb-2" }, [
          _c(
            "div",
            {
              staticClass:
                "progress-bar progress-bar-info progress-bar-striped",
              style: { width: _vm.progress + "%" },
              attrs: {
                role: "progressbar",
                "aria-valuenow": _vm.progress,
                "aria-valuemin": "0",
                "aria-valuemax": "100",
              },
            },
            [_vm._v("\r\n        " + _vm._s(_vm.progress) + "%\r\n      ")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "custom-file-wrapper mb-2" }, [
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            staticClass: "form-control",
            staticStyle: { "border-radius": "25px 0 0 25px !important" },
            attrs: { type: "text", readonly: "", placeholder: _vm.txtslfile },
            domProps: { value: _vm.selectedFileName },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.choseUpload()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.browseButtonText))]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("input", {
          ref: "file_0",
          staticStyle: { display: "none" },
          attrs: { type: "file", id: "file_0" },
          on: {
            change: function ($event) {
              return _vm.selectFile(0)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.message
        ? _c(
            "div",
            {
              staticClass: "small mb-2",
              class: {
                "text-info": !_vm.isUploadError,
                "text-danger": _vm.isUploadError,
              },
            },
            [_vm._v("\r\n            " + _vm._s(_vm.message) + "\r\n        ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-2" }, [
        _c(
          "button",
          {
            ref: "upplbutt_0",
            staticClass: "btn btn-primary",
            attrs: { type: "button", disabled: true },
            on: {
              click: function ($event) {
                return _vm.upload(0)
              },
            },
          },
          [_vm._v(_vm._s(_vm.txtupload))]
        ),
      ]),
      _vm._v(" "),
      _vm.messageupload
        ? _c("div", { staticClass: "small text-info" }, [
            _vm._v(
              "\r\n            " + _vm._s(_vm.messageupload) + "\r\n        "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }